import { FC } from 'react';
import { Question } from './Question';
import {
  useConnectMalfunctions,
  useCurrentQuestion,
  useQuestionnaire,
  useSubmitState,
} from '../../services/inspection';
import { DoneAlert, ErrorAlert, Footer } from './views';
import { Navigate } from 'react-router-dom';
import { Spinner } from '../../components/Spinner';
import { HeaderSlot, ShellContent } from '../../components/Shell';
import { QuestionnaireProgress } from './QuestionnaireProgress';
import { Subscribe } from '@react-rxjs/core';
import { PlaceCenter } from '../../components/PlaceCenter';
import { ProgressCircle } from '../../components/ProgressCircle';
import styles from './Inspection.module.css';
import { FormattedMessage } from 'react-intl';
import { MalfunctionQuestion } from './MalfunctionQuestion';
import { QuestionType } from './types';

export const Inspection: FC = () => (
  <Subscribe fallback={null}>
    <InspectionSubscribed />
  </Subscribe>
);

const InspectionSubscribed: FC = () => {
  const questionnaire = useQuestionnaire();
  const uploadState = useSubmitState();
  const question = useCurrentQuestion();
  useConnectMalfunctions();

  if (questionnaire === 'loading') {
    return (
      <PlaceCenter>
        <Spinner />
      </PlaceCenter>
    );
  }

  if (!questionnaire) {
    return <Navigate to="/" />;
  }

  if (uploadState?.running) {
    return (
      <div className={styles.submitting}>
        {uploadState.total ? <ProgressCircle {...uploadState} /> : <Spinner />}
        <div className={styles.submittingTitle}>
          <FormattedMessage id="Uploading" />…
        </div>
        <div className={styles.submittingContent}>
          <FormattedMessage
            id="Inspection.Submitting"
            values={{ b: (chunks) => <strong>{chunks}</strong> }}
          />
        </div>
      </div>
    );
  }

  return (
    <>
      <HeaderSlot slot="content">
        <QuestionnaireProgress />
      </HeaderSlot>
      <ShellContent>
        {question.type !== QuestionType.MALFUNCTION ? (
          <Question />
        ) : (
          <MalfunctionQuestion />
        )}
        <Footer />
        {uploadState?.error && <ErrorAlert />}
        {uploadState?.running === false && !uploadState.error && <DoneAlert />}
      </ShellContent>
    </>
  );
};
